export const projectsAll = [
     //Project 1
    {
        live: "https://hazrat-ali-blog.vercel.app",
        title: "Asset Optimex",
        video_key: "HvkrAjHJ-46",
        category: "typescript",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "TypeScript",
            "Next.js",
            "Mongoose",

        ],
        about_this_app:
            "Smart asset tracking and optimization",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/blog-site.jpg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9/Personal-Blog-Frontend",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Personal-Blog-Frontend",
        backend_dowload_link: "",
        project_image: "/blog-site.jpg",
        project_blog:
            "A blog site is a platform for sharing ideas, stories, and expertise through written content, images, and multimedia.",
            Type: "Reactjs",
        indevelopment: false,
    },
     //Project 2
     {
        live: "https://hazrat-ali-problem-solving.vercel.app",
        title: "Problem Solving",
        video_key: "HvkrAjHJ-46",
        category: "typescript",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "TypeScript",
            "Next.js",
            "Mongoose",
           
        ],
        about_this_app:
            "Smart asset tracking and optimization",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/problem-solving.jpg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9/Problem-Solving-Frontend",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Problem-Solving-Frontend",
        backend_dowload_link: "",
        project_image: "/blog-site.jpg",
        project_blog:
            "Problem solving is the process of identifying challenges and systematically finding effective solutions.",
            Type: "Reactjs",
        indevelopment: false,
    },
    //Project 3
    {
        live: "https://asset-optimizex.netlify.app/home",
        title: "Asset Optimex",
        video_key: "HvkrAjHJ-46",
        category: "python",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Python",
            "Django",
            "Postgresql",
            "React",

        ],
        about_this_app:
            "Smart asset tracking and optimization",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/images/project-10.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Asset_OptimizeX_Client",
        backend_dowload_link: "",
        project_image: "/images/project-10.png",
        project_blog:
            "Smart asset tracking and optimization.",
        Type: "python",
        indevelopment: false,
    },
    //Project 4
    {
        live: "https://bankmanagement.pythonanywhere.com/",
        title: "Bank Management",
        video_key: "HvkrAjHJ-46",
        category: "python",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Html",
            "Django",
            "Javascript",
            "Python"

        ],
        about_this_app:
            "Secure and efficient banking operations.",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/0845485.jpeg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Bank-Management",
        backend_dowload_link: "",
        project_image: "/0845485.jpeg",
        project_blog:
            "Secure and efficient banking operations.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 5
    {
        live: "https://online-work-platform.vercel.app/",
        title: "Work Platform",
        video_key: "HvkrAjHJ-46",
        category: "redux",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Html",
            "Tailwind",
            "Typescript",
            "Javascript",
            "Redux"

        ],
        about_this_app:
            "Streamlined collaboration and productivity in one place.",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "Html",
            "Tailwind",
            "Typescript",
            "Javascript",
            "Redux"
        ],
        image: "/images/project-13.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/online-work-platform-client",
        backend_dowload_link: "https://github.com/Hazrat-Ali9/online-work-platform-server",
        project_image: "/images/project-13.png",
        project_blog:
            "Streamlined collaboration and productivity in one place.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 6
    {
        title: "PC Builder",
        category: "redux",
        video_key: "HvkrAjHJ-38",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Tailwind",
            "Node js",
            "Redux",
            "Typescript",
            "Postgresql"
        ],
        about_this_app:
            "Contain StarMode , Drop Down NavBar , Authentication Google , Facebook , Github , Instgram , Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "@heroicons/react",
            "@reduxjs/toolkit",
            "@tailwindcss/line-clamp",
            "autoprefixer",
            "eslint",
            "eslint-config-next",
            "next",
            "next-auth",
            "next-redux-wrapper",
            "postcss",
            "react",
            "react-dom",
            "react-loader-spinner",
            "react-loading-skeleton",
            "react-onclickoutside",
            "react-redux",
            "tailwindcss"
        ],
        image: "/images/project-1.png",
        conclusion_blog: "",
        youtube_link: "https://youtu.com",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://https://github.com/Hazrat-Ali9/PC-Builder",
        backend_dowload_link: "",
        live: "https://pc-builder-lovat.vercel.app",
        project_image: "/images/project-1.png",
        project_blog:
            "Customize and build your perfect PC effortlessly.",
        Type: "React js",
        indevelopment: false,
    },
    //Project 7
    {
        title: "Mobile Accesories",
        category: "react",
        video_key: "HvkrAjHJ-39",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Html",
            "Javascript",
            "React",
            "Express",
            "MongoDB",
            "NodeJS",
        ],
        about_this_app:
            "Contain StarMode  Authentication Google , Facebook , Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/images/project-2.png",
        conclusion_blog: "",
        youtube_link: "",
        live: "https://hazrat-ali-mobile-accessories.netlify.app",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/manufacturer-client-side",
        backend_dowload_link: "https://github.com/Hazrat-Ali9/manufacturer-server-side",
        project_image: "/images/project-2.png",
        project_blog:
            "Essential add-ons for a better mobile experience.",
        Type: "React Js",
        indevelopment: false,
    },
    //Project 8
    {
        title: "Fitness",
        live: "https://hazrat-ali-fitness.netlify.app",
        category: "react",
        video_key: "HvkrAjHJ-40",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Html",
            "Javascript",
            "React",
        ],
        about_this_app:
            "Contain StarMode  Authentication Google , Facebook , Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/images/project-3.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Fitness",
        backend_dowload_link: "",
        project_image: "/images/project-3.png",
        project_blog:
            "Stay active, stay healthy!",
        Type: "React js",
        indevelopment: false,
    },
    //Project 9
    {
        live: "https://hazrat-ali-photographer.netlify.app",
        category: "react",
        title: "PhotoGrapher",
        video_key: "HvkrAjHJ-41",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Html",
            "Javascript",
            "React",
        ],
        about_this_app:
            "Contain StarMode  Authentication Google , Facebook , Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            
        ],
        image: "/photographer.jpeg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/PhotoGrapher",
        backend_dowload_link: "",
        project_image: "/photographer.jpeg",
        project_blog:
            "Capturing moments, creating memories",
        Type: "React Js",
        indevelopment: false,
    },
    //Project 10
    {
        title: "Book Catalog",
        live: "https://hazrat-book-catalog.netlify.app",
        category: "redux",
        video_key: "HvkrAjHJ-42",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "Tailwind",
            "React",
            "typescript",
            "Redux",
        ],
        about_this_app:
            "Contain StarMode  Authentication Google , Facebook , Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/images/project-5.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Book-Catalog-Frontend",
        backend_dowload_link: "https://github.com/Hazrat-Ali9/Book-Catalog-Server",
        project_image: "/images/project-5.png",
        project_blog:
            "Discover, organize, and explore your favorite books.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 11
    {
        live: "http://amazonshop.pythonanywhere.com/",
        title: "Amazon Shop",
        video_key: "HvkrAjHJ-46",
        category: "python",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "React",
            "Python",
            "Tailwind",
            "DaisyUi"

        ],
        about_this_app:
            "Contain StarMode  Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "React",
            "Tailwind",
            "DaisyUi",
            "Python"
        ],
        image: "/images/project-12.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Amazon-Shop",
        backend_dowload_link: "",
        project_image: "/images/project-12.png",
        project_blog:
            "Your one-stop destination for everything you need.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 12
    {
        live: "https://hazrat-ali-mobile-pc-watch.netlify.app",
        title: "Mobile PC Shop",
        video_key: "HvkrAjHJ-46",
        category: "react",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "html",
            "javascript",
            "css",
            "react",
            "Node",
            "express",
            "MongoDB"

        ],
        about_this_app:
            "Contain StarMode  Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/images/project-9.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Mobile-PC-Watch",
        backend_dowload_link: "",
        project_image: "/images/project-9.png",
        project_blog:
            "The ultimate store for mobile and PC devices.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 13
    {
        live: "https://hazrat-ali-mobile.netlify.app",
        category: "javascript",
        title: "Mobile Shop",
        video_key: "HvkrAjHJ-45",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "html",
            "css",

        ],
        about_this_app:
            "Contain StarMode  Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "html",
            "css"
        ],
        image: "/images/project-8.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Mobile-Shop",
        backend_dowload_link: "",
        project_image: "/images/project-8.png",
        project_blog:
            "Explore the latest smartphones and accessories.",
        Type: "Reactjs",
        indevelopment: false,
    },
    
    //Project 12
    
    // Project 7
    // Project 7 
    {
        live: "https://hazrat-ali-money.netlify.app",
        category: "javascript",
        title: "Money Master ",
        video_key: "HvkrAjHJ-44",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "html",
            "css",

        ],
        about_this_app:
            "Contain StarMode  Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "html",
            "css"
        ],
        image: "/images/project-7.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Money-Master",
        backend_dowload_link: "",
        project_image: "/images/project-7.png",
        project_blog:
            "Your personal guide to managing and growing your finances.",
        Type: "Reactjs",
        indevelopment: false,
    },

    {
        live: "https://hazrat-ali-influencer.netlify.app",
        category: "html",
        title: "Influencer Product ",
        video_key: "HvkrAjHJ-43",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        technology_feature: [
            "html",
            "css",

        ],
        about_this_app:
            "Contain StarMode  Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "html",
            "css"
        ],
        image: "/images/project-6.png",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https://github.com/Hazrat-Ali9/Influencer-Product",
        backend_dowload_link: "",
        project_image: "/images/project-6.png",
        project_blog:
            "Exclusive products curated by your favorite influencers.",
        Type: "Reactjs",
        indevelopment: false,
    },



];

export const clientReviews = [
    {
        user: {
            name: "John Doe",
            avatar: ""
        },
        text: "I was extremely satisfied with the service provided. Highly recommended!"
    },
    {
        user: {
            name: "Jane Smith",
            avatar: ""
        },
        text: "Outstanding customer support and quick response times. A+ service!"
    },
    {
        user: {
            name: "Michael Johnson",
            avatar: ""
        },
        text: "The product exceeded my expectations. Great quality and value."
    },
    {
        user: {
            name: "Sarah Brown",
            avatar: ""
        },
        text: "I'm a happy customer. The team went above and beyond to assist me."
    },
    {
        user: {
            name: "",
            avatar: ""
        },
        text: "Prompt delivery and excellent communication. Will buy again!"
    },
    {
        user: {
            name: "Emily Davis",
            avatar: ""
        },
        text: "The service was exceptional. I'm impressed with the professionalism."
    },
    {
        user: {
            name: "Robert Lee",
            avatar: ""
        },
        text: "I had a wonderful experience. Great product and support."
    },
    {
        user: {
            name: "Amanda Garcia",
            avatar: ""
        },
        text: "Top-notch service that I would recommend to anyone."
    },
    {
        user: {
            name: "William Clark",
            avatar: ""
        },
        text: "Reliable and trustworthy. I'm a satisfied and loyal customer."
    },
    {
        user: {
            name: "Laura White",
            avatar: ""
        },
        text: "Couldn't be happier with the product quality and customer care."
    }
];

